import React, { useMemo } from 'react';

import type { ScanQueueRowsInner } from '@rtkwlf/rendall';
import type { ColumnDef } from '@tanstack/react-table';
import { createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { ScannerStatus } from '../../../../../../../../../components/scanner-config/scanners-status';

interface ScannningQueueRowData extends ScanQueueRowsInner {
  tzLastScan: string;
}

const columnHelper = createColumnHelper<ScannningQueueRowData>();

export const useScanningQueueColumns = (): ColumnDef<
  ScannningQueueRowData,
  any
>[] => {
  const { t } = useTranslation('telemetryScannerConfig');

  return useMemo(
    () => [
      columnHelper.accessor('ipAddress', {
        cell: (info) => info.getValue(),
        enableSorting: true,
        header: t('scanningQueue.target'),
        id: 'ipAddress',
      }),
      columnHelper.accessor('status', {
        cell: (info) => <ScannerStatus value={info.getValue()} />,
        enableSorting: true,
        header: t('scanningQueue.status'),
        id: 'status',
      }),
      columnHelper.accessor('range', {
        cell: (info) => info.getValue(),
        enableSorting: true,
        header: t('scanningQueue.range'),
        id: 'range',
      }),
    ],
    [t],
  );
};
